import type { BaseController } from '@infra/controllers/base.controller';
import type {
  SupervisorListenRequest,
  SupervisorListenUsecase,
} from './supervisor-listening.usecase';

export class SupervisorListenInController
  implements BaseController<SupervisorListenRequest, void>
{
  constructor(private usecase: SupervisorListenUsecase) {}

  async handle(request: SupervisorListenRequest): Promise<void> {
    await this.usecase.run(request);
  }
}
